import dayjs from "dayjs"
import { find, some } from 'lodash'

let openedParentSession = JSON.parse(localStorage.getItem('opened_parent_session')) || null

const CACHE_KEY = 'ee-programme'

const sessions = {
  namespaced: true,

  state: {
    sessions: [],
    loaded: false,
    openedParentSession,
    search: '',
    sessionsSettings: {
      showSearch: true,
      showRoomFilter: false,
      showTopicFilter: false,
      filtersAboveDates: false
    }
  },

  mutations: {
    setSessions (state, sessions) {
      state.sessions = sessions
      state.loaded = true
    },
    setSessionsSettings (state, settings) {
      state.sessionsSettings = settings
    },
    changeOpenedParentSession: (state, session) => {
        if(!session.parent_id) {
          if(state.openedParentSession == session.id) {
            state.openedParentSession = null
            localStorage.setItem('opened_parent_session', JSON.stringify(null))
          } else {
              state.openedParentSession = session.id
              localStorage.setItem('opened_parent_session', JSON.stringify(session.id))
          }
        }
    },
    updateSearch (state, search) {
      state.search = search
    },
  },

  getters: {
    currentSession: state => roomId => {
      const currentTime = dayjs()

      return state.sessions.find(session => {
        const sessionStart = dayjs(session.start)
        const sessionEnd = dayjs(session.end)

        if (roomId && session.room_id !== roomId) {
          return false
        }

        return currentTime.isSameOrAfter(sessionStart) && currentTime.isSameOrBefore(sessionEnd)
      })
    },
    isOpenedParentSession: state => sessionId => {
      return state.openedParentSession == sessionId
    },

    showSession: (state, getters) => (id, subsessions) => {
      const session = find(subsessions || state.sessions, { id })
      if (!session) {
        return false
      }

      if (!state.search) {
        return !session.parent_id || state.openedParentSession == session.parent_id
      }

      const search = state.search.toLowerCase()
      // name and subtitle are translated and can be null when the translation is missing
      const contains = value => (value || '').toLowerCase().includes(search)

      const matchesSession = contains(session.name) || (session.code || '').toLowerCase() === search
      const matchesSpeaker = some(session.speakers, speaker =>
        contains(`${speaker.name} ${speaker.surname}`) || contains(speaker.subtitle)
      )

      return matchesSession || matchesSpeaker
    },

    sessionHasVisibleSubsessions: (state, getters) => id => {
      if(state.search) {
        const session = find(state.sessions, { id })
        const hasVisibleSubsessions = some(session.sub_sessions, subSession => getters.showSession(subSession.id, session.sub_sessions))
        return hasVisibleSubsessions
      }
      return true
    }
  },

  actions: {
    // The programme is big and slow to build: the last copy is kept in the browser and shown at once,
    // the fresh one replaces it when it arrives (stale-while-revalidate).
    getSessions ({ commit, state }) {
      if (!state.loaded) {
        try {
          const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null')
          if (cached && cached.lang === document.documentElement.lang) {
            commit('setSessions', cached.sessions)
            commit('setSessionsSettings', cached.settings)
          }
        } catch (e) {}
      }

      return axios.get('/sessions/data/')
        .then(response => {
          commit('setSessions', response.data.sessions)
          commit('setSessionsSettings', response.data.settings)
          try {
            localStorage.setItem(CACHE_KEY, JSON.stringify({
              lang: document.documentElement.lang, sessions: response.data.sessions, settings: response.data.settings,
            }))
          } catch (e) {}
        })
    }
  }
}

export default sessions
